import { render } from "./ReviewPdfScript.vue?vue&type=template&id=02f882e2"
import script from "./ReviewPdfScript.vue?vue&type=script&lang=js"
export * from "./ReviewPdfScript.vue?vue&type=script&lang=js"
script.render = render

export default script